module.exports = __webpack_public_path__ + "img/shop.5a7cdb8a.png";